query designWorkflowStages {
  designWorkflowStages {
    value
    label
    badgeVariant
  }
}

query designTypes {
  designTypes {
    value
    label
    badgeVariant
  }
}

query listDesigns {
  designs: listDesigns {
    id
    name
    designType
    baselineWorkspaceId
    designWorkspaceId
    sponsors {
      aggregateId
      preferredName
      firstName
      surname
      email
      avatar
      jobTitle
    }
    leads {
      aggregateId
      preferredName
      firstName
      surname
      email
      avatar
      jobTitle
    }
    participants {
      aggregateId
      preferredName
      firstName
      surname
      email
      avatar
      jobTitle
    }
    scopeRoots {
      workspaceId
      groupId
      group {
        id
        name
        type
        hierarchy
        hierarchyIds
      }
    }
    purpose
    benefits
    workflowStage
    startDate
    targetImplementationDate
    baselineDataDate
    createdAt
    updatedAt
  }
}

query listDesignWorkspaceIds {
  designs: listDesigns {
    id
    designWorkspaceId
  }
}

query listDesignWorkspaceOptions {
  designs: listDesigns {
    id
    designWorkspaceId
    baselineDataDate
    workflowStage
  }
}

query getDesignProvisioningStatus($id: ID!) {
  design: getDesign(id: $id) {
    id
    designWorkspaceId
    provisioning {
      clone {
        status
        updatedAt
      }
      dataSync {
        status
        updatedAt
      }
      roleAssignment {
        status
        updatedAt
      }
    }
  }
}

query getDesign($id: ID!) {
  design: getDesign(id: $id) {
    id
    tenantId
    name
    designType
    baselineWorkspaceId
    designWorkspaceId
    sponsors {
      aggregateId
      preferredName
      firstName
      surname
      email
      avatar
      jobTitle
    }
    leads {
      aggregateId
      preferredName
      firstName
      surname
      email
      avatar
      jobTitle
    }
    participants {
      aggregateId
      preferredName
      firstName
      surname
      email
      avatar
      jobTitle
    }
    scopeRoots {
      workspaceId
      groupId
      group {
        id
        name
        type
        hierarchy
        hierarchyIds
      }
    }
    primaryDriver
    purpose
    successCriteria
    benefits
    workflowStage
    startDate
    targetImplementationDate
    baselineDataDate
    createdAt
    updatedAt
  }
}

mutation createDesign($input: DesignInput!) {
  design: createDesign(input: $input) {
    id
    name
    baselineWorkspaceId
    designWorkspaceId
    workflowStage
    createdAt
    updatedAt
  }
}

mutation updateDesign($id: ID!, $input: DesignInput!) {
  design: updateDesign(id: $id, input: $input) {
    id
    name
    designType
    baselineWorkspaceId
    designWorkspaceId
    primaryDriver
    purpose
    successCriteria
    benefits
    workflowStage
    startDate
    targetImplementationDate
    baselineDataDate
    createdAt
    updatedAt
  }
}

mutation deleteDesign($id: ID!) {
  deleteDesign(id: $id) {
    deleted
  }
}

mutation reprovisionDesign($input: ReprovisionDesignInput!) {
  reprovisionDesign(input: $input) {
    cloneId
  }
}

mutation flattenDesignOption($id: ID!, $optionId: ID!) {
  option: flattenDesignOption(id: $id, optionId: $optionId) {
    id
    name
    isTrunk
  }
}
